<template>
  <v-container fluid class="pa-0">
    <div v-if="brandbar_show">
      <!-- Header -->
      <v-row
        id="v-app-bar--container"
        class="city-header d-flex align-center no-wrap pa-2 pt-0"
        no-gutters
      >
        <!-- Left: Badge -->
        <v-col class="flex-grow-0 flex-shrink-0 pr-0">
          <a href="https://renopd.com/" title="Reno PD .com">
            <img src="../images/gold-badge.png" class="badge-img pl-2" />
          </a>
        </v-col>

        <!-- Middle: Title (flexes, can shrink, never forces wrap) -->
        <v-col class="title-col white--text pl-2 pt-4 pt-md-5">
          <div class="mb-0">THE RENO</div>
          <div class="mb-0">POLICE DEPARTMENT</div>
          <div class="font-italic mb-0">Your Police, Our Community</div>
        </v-col>

        <!-- Desktop buttons: pinned right, only md+ -->
        <v-col
          class="flex-grow-0 flex-shrink-0 d-none d-md-flex align-center pr-0"
        >
          <v-btn
            href="https://iaforms.renopd.com/"
            target="_blank"
            title="Contact Us"
            class="join-btn join-btn-contact mr-2"
            small
            depressed
            elevation="2"
          >
            Contact<br />Us
          </v-btn>

          <v-btn
            href="https://renopd.com/Recruit"
            target="_blank"
            title="Join Our Team"
            class="join-btn mr-2"
            small
            depressed
            elevation="2"
          >
            Join<br />Our<br />Team!
          </v-btn>
        </v-col>

        <!-- Right: City logo -->
        <v-col class="flex-grow-0 flex-shrink-0 pr-0 d-flex justify-end">
          <a
            href="https://www.reno.gov/"
            target="_blank"
            title="City of Reno Home Page"
          >
            <img src="../images/city.png" class="city-img" />
          </a>
        </v-col>
      </v-row>

      <!-- Blue bar -->
      <div id="app-title-container" class="d-flex" style="width: 100%">
        <div id="blue-bar" class="mb-2">
          <v-row
            id="blue-bar-flex"
            class="d-flex align-center justify-space-between no-wrap pa-2"
            no-gutters
          >
            <v-col class="flex-grow-1 flex-shrink-1 px-0">
              <rpd_menu></rpd_menu>
            </v-col>

            <!-- Mobile buttons: only sm and down -->
            <v-col class="flex-grow-0 flex-shrink-0 d-flex d-md-none px-0">
              <v-btn
                href="https://renopd.com/Recruit"
                target="_blank"
                title="Join Our Team"
                class="join-btn-mobile mr-2"
                small
                depressed
                elevation="2"
              >
                Join Our Team!
              </v-btn>

              <v-btn
                href="https://renopd.com/cadets"
                target="_blank"
                title="Join Jr. Cadets"
                class="join-btn-mobile"
                small
                depressed
                elevation="2"
              >
                Join Jr Cadets!
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <v-spacer></v-spacer>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
/* ----- Shared helpers ----- */
.no-wrap {
  flex-wrap: nowrap !important;
}

/* ----- Header background and sizing ----- */
#v-app-bar--container {
  background-image: url(../images/jm-Header2.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Mobile header height */
.city-header {
  height: 67px;
  align-items: flex-start;
}

/* Images */
.badge-img {
  width: 53px !important;
}

.city-img {
  width: 25px;
}

/* Title sizing */
.title-col {
  line-height: 0.8rem;
  font-size: 12px;
  font-weight: 500;
  min-width: 0; /* CRITICAL: allows shrink instead of pushing others off */
}

/* ----- Blue bar ----- */
#blue-bar {
  background-color: #002e42 !important;
  color: white !important;
  max-width: 768px;
  width: 100%;
  height: 3.8em;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 0px;
  -webkit-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);
}

/* ----- Button coloring ----- */
.join-btn,
.join-btn-mobile {
  background-color: #4587c1 !important;
  color: #fff !important;
  text-transform: uppercase;
}

/* ----- Vuetify internal content alignment (scoped-safe) ----- */
:deep(.join-btn.v-btn),
:deep(.join-btn-mobile.v-btn) {
  min-width: 0 !important;
  padding: 0 !important;
}

:deep(.join-btn .v-btn__content),
:deep(.join-btn-mobile .v-btn__content) {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  white-space: normal !important;
  line-height: 1.1;
  text-align: center;
}

/* Desktop portrait buttons sizing */
@media (min-width: 768px) {
    /* Force Vuetify v-btn root to your portrait size */
  :deep(.join-btn.v-btn) {
    width: 60px !important;
    height: 69px !important;
    min-height: 69px !important;
    padding: 0 !important;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 1), 0 2px 10px 0 rgba(0, 0, 0, 1);
    border-radius: 2px;
  }

  /* Contact is wider */
  :deep(.join-btn-contact.v-btn) {
    width: 80px !important;
  }
  
  .city-header {
    height: 97px;
    align-items: center;
  }

  .badge-img {
    width: 77px !important;
  }

  .city-img {
    width: 35px;
  }

  .title-col {
    line-height: 1;
    font-size: 1.2rem !important;
    font-weight: 500;
  }

  .join-btn {
    width: 60px;
    height: 69px;
    font-size: 12px;
    padding-top: 7px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 1), 0 2px 10px 0 rgba(0, 0, 0, 1);
    border-radius: 2px;
  }

  .join-btn-contact {
    width: 80px;
  }

  #blue-bar {
    height: 2.5em;
  }
}

/* iPad landscape special case you had */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .container {
    padding: 12px 0;
    width: 100vw;
    max-width: 100vw;
  }

  .city-header {
    height: 130px;
  }

  .badge-img {
    width: 105px !important;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }
}

/* Desktop wide */
@media (min-width: 1025px) {
  .container {
    padding: 12px 0;
    width: 100%;
    max-width: 100%;
  }

  #v-app-bar--container {
    width: 100%;
    max-width: 100%;
    background-size: contain;
    background-repeat: repeat;
  }

  .city-header {
    height: 130px;
  }

  .badge-img {
    width: 105px !important;
  }

  .city-img {
    width: 50px;
  }

  #blue-bar {
    max-width: 100vw;
    width: 100vw;
  }
.city-header {
  margin-bottom: 0 !important;
}
#app-title-container {
  margin-bottom: 0 !important;
}

#blue-bar-flex {
  margin-bottom: 0 !important;
}
/* * { outline: 1px solid red; } */
}

</style>

<script>
import rpd_menu from "../components/rpd_menu.vue";

export default {
  name: "banner",
  components: { rpd_menu },
  data() {
    return {
      brandbar_show: true,
    };
  },
  mounted() {
    console.log("brand mounted");
    const payload = {
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    fetch("/Analytics/Track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Analytics tracking failed:", err);
    });
  },
};
</script>